import React, { PureComponent } from 'react';
import { string, bool, func } from 'prop-types';
import { connect } from 'react-redux';
import DOMPurify from 'dompurify';
import Radium from 'radium';
import { addTargetBlankToSelector } from '@widergy/web-utils/lib/dom';
import { UTButton } from '@widergy/energy-ui';

import { actionCreators as accountActions } from '../../../../../redux/accountHandlers';
import AuthFormBox from '../../../../components/AuthFormBox';
import { message } from '../../../../../utils/stringUtils';
import ReturnToSignIn from '../ReturnToSignIn';

import TermsAndConditions from './layout';
import styles from './styles';

class TermsAndConditionsContainer extends PureComponent {
  state = { acceptedTerms: false };

  componentWillMount() {
    this.props.dispatch(accountActions.getTermsAndConditions());
  }

  componentDidUpdate() {
    addTargetBlankToSelector('a');
  }

  createHtml = terms => ({ __html: DOMPurify.sanitize(terms) });

  handleCheckTerms = () => this.setState({ acceptedTerms: !this.state.acceptedTerms });

  render() {
    return (
      <div style={styles.container}>
        <AuthFormBox title={message('Signup:acceptTerms')}>
          <TermsAndConditions
            loading={this.props.termsLoading || this.props.signUpLoading}
            terms={this.createHtml(this.props.terms)}
            acceptedTerms={this.state.acceptedTerms}
            handleCheckTerms={this.handleCheckTerms}
          />
        </AuthFormBox>
        {!this.props.signUpLoading && !this.props.termsLoading && (
          <React.Fragment>
            <UTButton
              disabled={!this.state.acceptedTerms}
              style={styles.button}
              onPress={this.props.onSubmit}
            >
              {message('Signup:next')}
            </UTButton>
            <ReturnToSignIn />
          </React.Fragment>
        )}
      </div>
    );
  }
}

TermsAndConditionsContainer.propTypes = {
  terms: string,
  termsLoading: bool.isRequired,
  signUpLoading: bool.isRequired,
  onSubmit: func.isRequired
};

const mapStateToProps = store => ({
  terms: store.account.terms,
  termsLoading: store.account.termsLoading,
  signUpLoading: store.auth.signUpLoading
});

export default connect(mapStateToProps)(Radium(TermsAndConditionsContainer));
